import { enhance } from './QuestionsContainer'
import Horizontal from './QuestionsHorizontal'

export const QuestionsHorizontal = enhance(Horizontal)
